import { FC } from 'react';

import { CAMPAIGN_SOCIAL_SOURCES, CampaignSubSource } from 'utils/constants/campaign';

import useTrls from 'hooks/translation/useTrls';

const SocialShows: FC<{ sources: CampaignSubSource[] }> = ({ sources }) => {
    const trl = useTrls();

    const intersection = sources.filter((source) => CAMPAIGN_SOCIAL_SOURCES.includes(source));
    if (intersection.length === 0) {
        return null;
    }
    return <p>{trl('campaign.targetings.sources.social')}</p>;
};

export default SocialShows;
